import React from 'react'

const Footer = () => {
  return (
    <div className='bg-[#212529] w-full h-[80px] mb-[80px] md:mb-0 mt-5'>
      <p className='text-white text-center font-medium py-6'>© Copyright. All right reserved.</p>
    </div>
  )
}

export default Footer
